<template>
    <div>
        <div class="flex mt-4 justify-between gap-4">
            <div class="flex mt-4 gap-4">
                <div class="table__search-input-wrapper">
                    <span class="pr-2 opacity-50"><search-icon /> </span>
                    <input
                        type="text"
                        class="table__search-input"
                        placeholder="Search..."
                        v-model="querySearch"
                    />
                    <img src="@/assets/images/icons/search.svg" alt="search icon" />
                </div> 
                <div class="input-wrapper">
                    <!-- <label for="cost-center" class="">Tags</label> -->
                    <el-select multiple v-model="category"  placeholder="--Filter by Category">
                        <el-option
                        label="tag.name"
                        value="tag.id"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div> 
            <base-button text="+ New Location"  @click="showAddLocationModal = true"/>
        </div>
        <div class="flex flex-col gap-2 justify-center items-center"> 
            <span>
                <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.5">
                    <path d="M131.25 28.125H18.75C14.8667 28.125 11.7188 31.273 11.7188 35.1562V112.5C11.7188 116.383 14.8667 119.531 18.75 119.531H131.25C135.133 119.531 138.281 116.383 138.281 112.5V35.1562C138.281 31.273 135.133 28.125 131.25 28.125Z" fill="#7B858F"/>
                    <path d="M93.75 142.969H56.25L61.875 124.219L63.2812 119.531H86.7188L88.125 124.219L93.75 142.969Z" fill="#D5D5D3"/>
                    <path d="M49.2188 140.625H100.781V145.312H49.2188V140.625Z" fill="#DFDFDD"/>
                    <path d="M88.125 124.219H61.875L63.2813 119.531H86.7188L88.125 124.219Z" fill="#CECECC"/>
                    <path d="M138.281 103.125V112.5C138.281 114.365 137.54 116.153 136.221 117.471C134.903 118.79 133.115 119.531 131.25 119.531H18.75C16.8853 119.531 15.0972 118.79 13.7787 117.471C12.4602 116.153 11.7192 114.365 11.7188 112.5V103.125H138.281Z" fill="#DFDFDD"/>
                    <path d="M119.531 7.03125H30.4688C28.6039 7.03125 26.8155 7.77204 25.4969 9.09066C24.1783 10.4093 23.4375 12.1977 23.4375 14.0625V103.125H126.562V14.0625C126.562 12.1977 125.822 10.4093 124.503 9.09066C123.184 7.77204 121.396 7.03125 119.531 7.03125Z" fill="#5E646D"/>
                    <path d="M23.4375 98.4375H126.562V103.125H23.4375V98.4375Z" fill="#507FDF"/>
                    <path d="M11.7188 98.4375H23.4375V103.125H11.7188V98.4375Z" fill="#2F80ED"/>
                    <path d="M126.562 98.4375H138.281V103.125H126.562V98.4375Z" fill="#2F80ED"/>
                    <path d="M39.8438 58.5938H58.5938V63.2812H39.8438V58.5938Z" fill="#507FDF"/>
                    <path d="M67.9688 58.5938H82.0312V63.2812H67.9688V58.5938Z" fill="#507FDF"/>
                    <path d="M91.4062 58.5938H107.812V63.2812H91.4062V58.5938Z" fill="#507FDF"/>
                    <path d="M37.5 67.9688C41.3833 67.9688 44.5312 64.8208 44.5312 60.9375C44.5312 57.0542 41.3833 53.9062 37.5 53.9062C33.6167 53.9062 30.4688 57.0542 30.4688 60.9375C30.4688 64.8208 33.6167 67.9688 37.5 67.9688Z" fill="#2F80ED"/>
                    <path d="M63.2812 67.9688C67.1645 67.9688 70.3125 64.8208 70.3125 60.9375C70.3125 57.0542 67.1645 53.9062 63.2812 53.9062C59.398 53.9062 56.25 57.0542 56.25 60.9375C56.25 64.8208 59.398 67.9688 63.2812 67.9688Z" fill="#2F80ED"/>
                    <path d="M86.7188 67.9688C90.602 67.9688 93.75 64.8208 93.75 60.9375C93.75 57.0542 90.602 53.9062 86.7188 53.9062C82.8355 53.9062 79.6875 57.0542 79.6875 60.9375C79.6875 64.8208 82.8355 67.9688 86.7188 67.9688Z" fill="#333333"/>
                    <path d="M112.5 67.9688C116.383 67.9688 119.531 64.8208 119.531 60.9375C119.531 57.0542 116.383 53.9062 112.5 53.9062C108.617 53.9062 105.469 57.0542 105.469 60.9375C105.469 64.8208 108.617 67.9688 112.5 67.9688Z" fill="#2F80ED"/>
                    <path d="M32.8125 72.6562H42.1875V77.3438H32.8125V72.6562Z" fill="#507FDF"/>
                    <path d="M58.5938 72.6562H67.9688V77.3438H58.5938V72.6562Z" fill="#507FDF"/>
                    <path d="M82.0312 72.6562H91.4062V77.3438H82.0312V72.6562Z" fill="#507FDF"/>
                    <path d="M107.812 72.6562H117.188V77.3438H107.812V72.6562Z" fill="#507FDF"/>
                    <path d="M30.4688 14.0625H35.1562V18.75H30.4688V14.0625Z" fill="#3BA5D3"/>
                    <path d="M39.8438 14.0625H44.5312V18.75H39.8438V14.0625Z" fill="#3BA5D3"/>
                    <path d="M49.2188 14.0625H53.9062V18.75H49.2188V14.0625Z" fill="#3BA5D3"/>
                    <path d="M30.4688 23.4375H119.531V28.125H30.4688V23.4375Z" fill="#1034A6"/>
                    <path d="M32.8125 84.375H65.625V89.0625H32.8125V84.375Z" fill="#3BA5D3"/>
                    <path d="M30.4688 32.8125H51.5625V37.5H30.4688V32.8125Z" fill="#3BA5D3"/>
                    <path d="M30.4688 42.1875H46.875V46.875H30.4688V42.1875Z" fill="#3BA5D3"/>
                    <path d="M105.469 32.8125H119.531V37.5H105.469V32.8125Z" fill="#3BA5D3"/>
                    <path d="M105.469 42.1875H119.531V46.875H105.469V42.1875Z" fill="#3BA5D3"/>
                    <path d="M107.812 114.844L134.481 141.512C135.414 142.445 136.678 142.969 137.997 142.969C139.315 142.969 140.58 142.445 141.512 141.512C142.445 140.58 142.969 139.315 142.969 137.997C142.969 136.678 142.445 135.414 141.512 134.481L114.844 107.812L107.812 114.844Z" fill="#F15846"/>
                    <path d="M100.781 126.562C116.314 126.562 128.906 113.971 128.906 98.4375C128.906 82.9045 116.314 70.3125 100.781 70.3125C85.2482 70.3125 72.6562 82.9045 72.6562 98.4375C72.6562 113.971 85.2482 126.562 100.781 126.562Z" fill="#F15846"/>
                    <path d="M100.781 117.188C111.137 117.188 119.531 108.793 119.531 98.4375C119.531 88.0822 111.137 79.6875 100.781 79.6875C90.4259 79.6875 82.0312 88.0822 82.0312 98.4375C82.0312 108.793 90.4259 117.188 100.781 117.188Z" fill="#4AAEDA"/>
                    <path d="M100.781 112.5C108.548 112.5 114.844 106.204 114.844 98.4375C114.844 90.671 108.548 84.375 100.781 84.375C93.0147 84.375 86.7188 90.671 86.7188 98.4375C86.7188 106.204 93.0147 112.5 100.781 112.5Z" fill="#4DB6E4"/>
                    <path d="M93.75 98.4375H89.0625C89.066 95.3306 90.3018 92.3519 92.4987 90.1549C94.6956 87.958 97.6743 86.7222 100.781 86.7188V91.4062C98.9171 91.4084 97.1299 92.1499 95.8118 93.4681C94.4937 94.7862 93.7522 96.5734 93.75 98.4375V98.4375Z" fill="#5CC1ED"/>
                    <path d="M95.7129 34.2832L86.7188 46.875L77.7246 34.2832C75.9525 31.8024 75 28.8299 75 25.7812C75 22.6732 76.2347 19.6925 78.4323 17.4948C80.63 15.2972 83.6107 14.0625 86.7188 14.0625C89.8268 14.0625 92.8075 15.2972 95.0052 17.4948C97.2028 19.6925 98.4375 22.6732 98.4375 25.7812C98.4375 28.8299 97.485 31.8024 95.7129 34.2832Z" fill="#111519"/>
                    <path d="M86.7188 30.4688C89.3076 30.4688 91.4062 28.3701 91.4062 25.7812C91.4062 23.1924 89.3076 21.0938 86.7188 21.0938C84.1299 21.0938 82.0312 23.1924 82.0312 25.7812C82.0312 28.3701 84.1299 30.4688 86.7188 30.4688Z" fill="#333333"/>
                    </g>
                </svg>
            </span>
            <p>You have not associated accounts with your locations (Warehouse | Outlets | Stores | etc.). To associate accounts.</p>
            <p @click="showAddLocationModal = true" class="text-primary-yellow cursor-pointer"> click on Locations to start.</p>
        </div>
        <table class="custom-table mt-8 w-100">
             <thead>
                 <tr>
                     <th>#</th>
                     <th>.</th>
                     <th>LOCATION NAME</th>
                     <th>PAY CATEGORIES</th>
                     <th>ACCOUNTS</th>
                     <th>DEFAULT</th>
                 </tr>
             </thead>
             <tbody>
                 <tr>
                     <td>1</td>
                     <td>
                         <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="5.5" cy="5" r="5" fill="#13B56A"/>
                        </svg>
                     </td>
                     <td>Apata ganga</td>                     
                     <td><badge type="yellow">Salary</badge></td>
                     <td>
                         <div class="flex gap-2 items-center">
                            <span class="">3</span>
                            <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.8309 9C13.8309 10.1046 12.9355 11 11.8309 11C10.7264 11 9.83093 10.1046 9.83093 9C9.83093 7.89543 10.7264 7 11.8309 7C12.9355 7 13.8309 7.89543 13.8309 9Z" fill="#10233E"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8309 0C6.23941 0 1.54111 3.82432 0.208984 9C1.54111 14.1757 6.23941 18 11.8309 18C17.4224 18 22.1207 14.1757 23.4529 9C22.1207 3.82432 17.4224 0 11.8309 0ZM15.8309 9C15.8309 11.2091 14.0401 13 11.8309 13C9.62179 13 7.83093 11.2091 7.83093 9C7.83093 6.79086 9.62179 5 11.8309 5C14.0401 5 15.8309 6.79086 15.8309 9Z" fill="#10233E"/>
                            </svg>
                         </div>
                    </td>
                    <td>
                        Scello Limited
                        <p class="text-primary-yellow font-semibold">Wema bank</p>
                     </td>
                     <td>
                         <span>
                             <svg width="18" height="5" viewBox="0 0 18 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5C0.89543 4.5 0 3.60457 0 2.5C0 1.39543 0.89543 0.5 2 0.5C3.10457 0.5 4 1.39543 4 2.5C4 3.60457 3.10457 4.5 2 4.5ZM9 4.5C7.89543 4.5 7 3.60457 7 2.5C7 1.39543 7.89543 0.5 9 0.5C10.1046 0.5 11 1.39543 11 2.5C11 3.60457 10.1046 4.5 9 4.5ZM14 2.5C14 3.60457 14.8954 4.5 16 4.5C17.1046 4.5 18 3.60457 18 2.5C18 1.39543 17.1046 0.5 16 0.5C14.8954 0.5 14 1.39543 14 2.5Z" fill="#10233E"/>
                            </svg>
                         </span>
                     </td>
                 </tr>
             </tbody>
        </table>
        <hr>
        <div class="flex justify-between">
            <p class="cursor-pointer ">Cancel</p>
            <base-button text="Save" />
        </div>
        <add-location-modal :showModal="showAddLocationModal" @close-modal="showAddLocationModal = false"/>
    </div>
</template>

<script>
import AddLocationModal from "../Modals/AddLocationModal"

export default{
    components:{
        AddLocationModal
    },
    data(){
        return {
            querySearch: '',
            category: "",
            showAddLocationModal: false 
        }
    }
}
</script>

<style lang="scss">


</style>